import { Badge, BadgeSize } from '@prishapolicy/shared/ui';
import dayjs from 'dayjs';
import HashtagIcon from 'remixicon-react/HashtagIcon';
import { badgeTagsMap } from './badge-tags-map';

export const blogTools = {
  readTimeAndDate: (date: string | Date | undefined, minutesToRead: number | undefined) => {
    if (date === undefined || minutesToRead === undefined) {
      return null;
    }
    return (
      <p className="text-grey-600 text-body-3">{`${dayjs(date).format('MMMM DD, YY')} | ${minutesToRead} min read`}</p>
    );
  },
  badgeRender: (tags: string[], size?: BadgeSize) => {
    if (tags.length === 0) {
      return null;
    }
    return (
      <>
        {tags.map((el) => (
          <Badge
            text={el}
            size={size ? size : 'small'}
            variant="lozenge"
            icon={HashtagIcon}
            iconClass="w-3"
            key={el}
            theme={badgeTagsMap[el] || 'grey'}
          />
        ))}
      </>
    );
  },
};
